import * as api from '../../api/api-descarga-casos';
import {
    OBTENER_LLAVES,
    GET_CONFIG_FORM_DESC,
    GET_TIPOS_DESCARGA,
    GET_RESPONSABLES,
    GET_CRITERIOS_FECHA_DESC,
    GET_DESC_PREVIAS,
    POST_GENERAR_DESCARGA

} from '../types';


export const obtenerDatosLlaves = (llaves) => ({
    type:OBTENER_LLAVES,
    payload: llaves
});
export const configuracionFormAction = (query) => ({
    type: GET_CONFIG_FORM_DESC,
    payload: api.getConfiguracionForm(query)
});
export const obtenerTiposDescarga = (query) => ({
    type: GET_TIPOS_DESCARGA,
    payload: api.getDetalles(query)
});
export const obtenerResponsables = (query) => ({
    type: GET_RESPONSABLES,
    payload: api.getResponsables(query)
});
export const obtenerCriteriosFecha = (query) => ({
    type: GET_CRITERIOS_FECHA_DESC,
    payload: api.getDetalles(query)
});
//RG-536 el Criterio por Fecha sale de cfg_filtro_informes (299002 / 288002) y depende del Tipo de
//Descarga. Escribe en la misma clave del store que la carga anterior por `detalles concepto 305`.
export const obtenerCriteriosFechaFiltro = (query) => ({
    type: GET_CRITERIOS_FECHA_DESC,
    payload: api.getOpcionesFiltro(query)
});
export const obtenerDescargasPrevias = (query) => ({
    type: GET_DESC_PREVIAS,
    payload: api.getDescargasPrevias(query)
});
export const generarDescarga = (data) => ({
    type: POST_GENERAR_DESCARGA,
    payload: api.postGenerarDescarga(data)
});